.code-block {
  max-width: 100%;
  overflow-x: auto;
}

.code-block code {
  padding: 0;
  background: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  padding-inline: var(--mantine-spacing-sm);
  padding-bottom: calc(var(--mantine-spacing-xs) / 2);
  margin-inline: calc(var(--mantine-spacing-sm) * -1);
  margin-bottom: calc(var(--mantine-spacing-xs) / 2);
  font-weight: 600;
  border-bottom: 1px solid var(--mantine-color-dark-5);
}
h1 {
  font-size: calc(var(--text-fz) * 1.4);
}
h2 {
  font-size: calc(var(--text-fz) * 1.3);
}
h3 {
  font-size: calc(var(--text-fz) * 1.2);
}
h4,
h5,
h6 {
  font-size: calc(var(--text-fz) * 1.1);
}

p {
  margin-block: var(--mantine-spacing-xs);
}

ul,
ol {
  padding-inline-start: var(--mantine-spacing-lg);
  margin-block: var(--mantine-spacing-xs);
}
ul {
  list-style: square;
  ::marker {
    color: var(--mantine-color-dark-4);
  }
}
